module.exports = "pegasus/assets/blocks/column-lp4-basic.png";